import { Button } from "../../../../../../components/ui/Button";
import { useTranslation } from "../../../../../../lib/i18n";
import { useDataTranslation } from "../../../../../../lib/i18n/data";
import { BeautyProfilerAllure } from "../../../../types/BeautyProfilerAllure";

type BeautyProfilerAllureSectionProps = {
  topAllure: BeautyProfilerAllure | null;
  onDiscoverClick: () => void;
};

export const BeautyProfilerAllureSection = ({
  topAllure,
  onDiscoverClick,
}: BeautyProfilerAllureSectionProps) => {
  const { t } = useTranslation();
  const { tData } = useDataTranslation();

  const allureLabel = topAllure
    ? tData('allures', topAllure.id, 'label', topAllure.label)
    : '';
  const allureDescription = topAllure
    ? tData('allures', topAllure.id, 'description', topAllure.description)
    : '';

  return (
    <div className="flex flex-col items-center gap-2 p-4 z-1">
      <div>
        <p className="text-[#050505] text-center font-garamond-italic text-[20px] italic font-normal">
          {t('results.beauty.stepInto')}
        </p>
        <h1 className="text-[#050505] text-center font-bebas-kai text-[37px] font-normal leading-normal">
          {t('results.beauty.the')} <span className="text-primary">{allureLabel}</span> {t('results.beauty.allureALaLouboutin')}
        </h1>
      </div>
      <p className="text-[#050505] text-justify font-minion text-[20px] font-normal leading-[150%]">
        {allureDescription}
      </p>
      <Button variant="discover" onClick={onDiscoverClick}>
        <p className="px-4">{t('discover')}</p>
      </Button>
    </div>
  );
};
